/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Check_NoteInputs */

const en_how_we_work_check_note = /** @type {(inputs: How_We_Work_Check_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example test scenarios. The expected behaviour is agreed together.`)
};

const lv_how_we_work_check_note = /** @type {(inputs: How_We_Work_Check_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piemēra pārbaudes scenāriji. Sagaidāmo rīcību saskaņojam kopā.`)
};

/**
* | output |
* | --- |
* | "Example test scenarios. The expected behaviour is agreed together." |
*
* @param {How_We_Work_Check_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_check_note = /** @type {((inputs?: How_We_Work_Check_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Check_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_check_note(inputs)
	return en_how_we_work_check_note(inputs)
});